@if (label(); as label) {
  <label class="text-xs font-medium text-foreground-primary-60"
    >{{ label }}
    @if (isRequired()) {
      <span class="text-status-error">*</span>
    }
  </label>
}

@if (editorOptions) {
  <ngx-monaco-editor
    class="flex-1 rounded-radius-cta"
    [options]="editorOptions"
    [(ngModel)]="fileContent"
    (ngModelChange)="onFileContentChange($event)"
    (onInit)="onEditorInit($event)"
  ></ngx-monaco-editor>
}

@if (allErrors.length > 0) {
  <div class="flex flex-row text-xs font-medium text-status-error">
    <div class="flex flex-col py-[2px]">
      @if (customErrorMessage(); as customErrorMessage) {
        <div>{{ customErrorMessage }}</div>
      }

      @for (error of errors; track error) {
        <div>{{ error }}</div>
      }
    </div>
  </div>
}
